module.exports = __webpack_public_path__ + "img/stripe.d31bef05.png";